import { createStore } from 'vuex';
//ouverture/fermeture de la sidenav
export default createStore({
  state: {
    sidebarOpen: true,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
  },
});
